import authActions from './authActions';
import userActions from './userActions';

export default {
  ...authActions,
  ...userActions
};



// WEBPACK FOOTER //
// ./src/lib/redux/actions/index.js